<template>
  <div class="app-footer">
    <div>
      <v-btn v-for="link in social" :key="link.ID" class="primary--text" flat icon large :href="link.url" target="_blank">
        <v-icon :title="link.post_title">mdi-{{ link.post_name }}</v-icon>
      </v-btn>
    </div>
    <div>
      <router-link to="/impressum">Impressum</router-link>
      <router-link to="/dsgvo">Datenschutz</router-link>
    </div>
    <p>powered by <a href="http://www.runit.at">runIT</a></p>
  </div>
</template>

<script>
export default {
  name: 'app-footer',
  data: () => ({
    social: [
      { post_name: 'facebook', post_title: 'Facebook', url: 'https://www.facebook.com/pillweinoptik/' },
      { post_name: 'instagram', post_title: 'Instagram', url: 'https://www.instagram.com/optik_pillwein/' }
    ]
  }),
  computed: {
    mobile () { return this.$vuetify.breakpoint.smAndDown }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/theme';

.app-footer {
  position: relative;
  width: 100%;
  padding: 32px 0;
  text-align: center;
  background-color: $COLOR_ACCENT_LIGHT;
  > div:nth-of-type(2) {
    margin-bottom: 16px;
    a { margin: 0 12px; }
  }
}
</style>
